import React, {useEffect, useRef, useState} from 'react';
import {useRecoilState} from "recoil";
import {loadingAtom} from "../atoms";
import Cookies from "js-cookie";
import {isDateAfterCurrent, isOver} from "../core/date";
import {useNavigate, useParams} from "react-router-dom";

import {formatLocalDate, parseLocalDate} from "../utils/utils";
import DateSelector from "./DateSelector";
import DeleteButton from '../components/common/DeleteButton';
const CustomerAutoFilling_Kids = (props, {onCustomerAdded}) => {
    const {kidIndex} = useParams();
    const navigate = useNavigate();
    const customerKey = Cookies.get('customerKey');
    const companyImg = Cookies.get('selfRegistrationImagePath') || null;
    const [customerKeyValid, setCustomerKeyValid] = useState(false);

    const [, setLoading] = useRecoilState(loadingAtom);
    const [addNewKid, setAddNewKid] = useState(false);

    const currentCustomerAutoFilling = Cookies.get('customerAutoFilling');

    const inputTextKidName = useRef();
    const inputTextKidBirthDateDay = useRef();
    const inputTextKidBirthDateMonth = useRef();
    const inputTextKidBirthDateYear = useRef();

    const newEntity = {
        id: undefined,
        name: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        cep: '',
        city: '',
        state: '',
        phone: '',
        email: '',
        instagram: '@',
        birthDate: undefined,
        rg: '',
        cpf: '',
        delivery: false,
        spaceBorneDelivery: false,
        howDidYouFindUs: '',
        referral: '',
        kids: []
    };

    const newKid = {name: '', birthDate: undefined};


    const [formData, setFormData] = useState(currentCustomerAutoFilling ? JSON.parse(currentCustomerAutoFilling) : newEntity);
    const [currentKid, setCurrentKid] = useState(newKid);

    useEffect(() => {
        // Validate customer key
        if (customerKey) {
            setCustomerKeyValid(true);
        } else {
            setCustomerKeyValid(false);
            navigate(`/autocadastro/linkInvalido`);
            return;
        }
        
        setCurrentKid(currentKid);
        setAddNewKid(Number(kidIndex) === 0 && formData.kids.length === 0);
        if(inputTextKidName.current) {
            inputTextKidName.current.focus();
        }
    }, [customerKey, kidIndex, navigate])

    useEffect(() => {
        const kid = Number(kidIndex) === formData.kids.length ? newKid : formData.kids[kidIndex];
        setCurrentKid(kid);
        setAddNewKid(Number(kidIndex) === 0 && formData.kids.length === 0);
    }, [kidIndex])
    const handleSaveButtonClick = async () => {

        try {
            if (validateInputs()) {
                await save();
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        }
    };

    function validateInputs() {


        if (!currentKid.name || currentKid.name === '') {
            alert('Preencha o campo nome.');
            if(inputTextKidName.current) {
                inputTextKidName.current.focus();
            }
            return false;
        }

        if (!currentKid.birthDate || currentKid.birthDate === '') {
            alert('Preencha o campo data de nascimento.');
            if(inputTextKidBirthDateDay.current) {
                inputTextKidBirthDateDay.current.focus();
            }
            return false;
        }

        if (isOver(parseLocalDate(currentKid.birthDate), 10)) {
            alert('Data de nascimento inválida. Maior que 10 anos.');
            if(inputTextKidBirthDateDay.current) {
                inputTextKidBirthDateDay.current.focus();
            }
            return false;
        }

        if (isDateAfterCurrent(parseLocalDate(currentKid.birthDate))) {
            alert('Data de nascimento inválida. Data posterior à data de hoje.');
            if(inputTextKidBirthDateDay.current) {
                inputTextKidBirthDateDay.current.focus();
            }
            return false;
        }

        return true;
    }

    async function save() {
        if (!kidIndex) {
            formData.kids.push(currentKid);
        } else {
            formData.kids[kidIndex] = currentKid;
        }
        Cookies.set('customerAutoFilling', JSON.stringify(formData));
        navigate(`/autocadastro/crianca/${Number(kidIndex) + 1}`);

    }


    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setCurrentKid((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleBirthDateChange = (dateStr) => {
        setCurrentKid((prevData) => ({
            ...prevData,
            birthDate: dateStr
        }));
    };

    function handleContinue() {
        navigate(`/autocadastro/sobre`);
    }

    function handleAddButtonClick() {
        setAddNewKid(true);
    }

    function handleBackButtonClick() {
        if(Number(kidIndex) === 0) {
            navigate(`/autocadastro/contato`);
        } else {
            navigate(`/autocadastro/crianca/${(kidIndex - 1)}`);
        }
    }

    function handleRemoveButtonClick() {
        const novaLista = [...formData.kids];
        novaLista.splice(Number(kidIndex), 1);
        const newFormData = ({
            ...formData,
            kids: novaLista
        });
        setFormData(newFormData);
        Cookies.set('customerAutoFilling', JSON.stringify(newFormData));
        if(Number(kidIndex) === 0) {
            if(novaLista.length > 0) {
                setCurrentKid(novaLista[0]);
            } else {
                setCurrentKid(newKid);
            }
            navigate(`/autocadastro/crianca/0`);
        } else {
            setCurrentKid(formData.kids[Number(kidIndex)-1]);
            navigate(`/autocadastro/crianca/${(Number(kidIndex) - 1)}`);
        }
    }

    return (
        <div>
            <div style={{textAlign: 'center'}}><h2>Ficha Cadastral - Criança</h2></div>

            {companyImg && <div style={{textAlign: 'center'}}><img src={companyImg} alt="Logo"/></div>}
            {!addNewKid && Number(kidIndex) > 0 && Number(kidIndex) === formData.kids.length ?
                (<div>
                    <div>
                        Adicionar mais uma criança?
                    </div>
                    <div>
                        <button onClick={handleAddButtonClick}>Sim</button>
                        <button onClick={handleContinue}>Não</button>
                    </div>

                </div>) : (<>
                    <div style={{marginTop: '10px', alignItems: 'center'}}>
                        <div style={{width: '300px'}}>Nome da Criança:</div>
                        <input style={{width: '300px'}} ref={inputTextKidName} type="text" id="name" value={currentKid.name} name="name"
                               onChange={handleChange}/>
                    </div>
                    <div style={{marginTop: '10px', alignItems: 'center'}}>
                        <div style={{width: '320px'}}>Data de nascimento da criança:</div>
                        <DateSelector
                            value={currentKid.birthDate}
                            onChange={handleBirthDateChange}
                            dayRef={inputTextKidBirthDateDay}
                            monthRef={inputTextKidBirthDateMonth}
                            yearRef={inputTextKidBirthDateYear}
                            minYear={new Date().getFullYear() - 10}
                        />
                    </div>


                    <div style={{marginTop: '10px', alignItems: 'center'}}>
                        <button onClick={handleBackButtonClick}>Voltar</button>
                        {formData.kids.length > 1 && Number(kidIndex) < formData.kids.length && (
                            <DeleteButton title="Remover" onClick={handleRemoveButtonClick}/>
                        )}
                        <button onClick={handleSaveButtonClick}>Continuar</button>
                    </div>
                </>)}


        </div>
    );
};

export default CustomerAutoFilling_Kids; 